import { LOCALES, useTranslation, type Locale } from "../i18n";

/**
 * Two-option language switch for the topbar. The pill draws both options at
 * once, so the reader sees which languages exist, not only the current one.
 */
export function LocaleToggle() {
  const { t, locale, setLocale } = useTranslation();

  return (
    <fieldset
      aria-label={t("common.language.label")}
      className="locale-seg"
      data-active={locale}
      data-testid="locale-toggle"
    >
      <span className="locale-seg-thumb" aria-hidden="true" />
      {LOCALES.map((l: Locale) => (
        <button
          key={l}
          type="button"
          className="locale-seg-opt"
          aria-pressed={l === locale}
          aria-label={t(`common.language.${l}`)}
          title={t(`common.language.${l}`)}
          data-testid={`locale-${l}`}
          onClick={() => setLocale(l)}
        >
          {l}
        </button>
      ))}
    </fieldset>
  );
}
